import produce from 'immer';
import {
    ACTION_GET_CAPTCHA_ERROR,
    ACTION_GET_CAPTCHA_SUCCESS,
    ACTION_TERMINATE_CONTRACT_ERROR,
    ACTION_TERMINATE_CONTRACT_SUCCESS,
} from './constant';
import { Action } from './action';
import { IStateCancellationForm } from './interface';

/**
 * Export initalState
 */
export const initialState: IStateCancellationForm = {
    customerInformation: null,
    error: null,
    captchaUrl: null,
    captchaMediaType: null,
    captchaHash: null,
};

/**
 * @param {*} state - Initial state of the app
 * @param {*} action - The action dispatched from saga
 */
const cancellationFormReducer = (state = initialState, action: Action) =>
    produce(state, draft => {
        switch (action.type) {
            case ACTION_TERMINATE_CONTRACT_SUCCESS:
                draft.customerInformation = action.customerInformation;
                break;
            case ACTION_GET_CAPTCHA_ERROR:
            case ACTION_TERMINATE_CONTRACT_ERROR:
                draft.error = action.error;
                break;
            case ACTION_GET_CAPTCHA_SUCCESS:
                draft.captchaHash = action.captchaHash;
                draft.captchaMediaType = action.captchaMediaType;
                draft.captchaUrl = action.captchaUrl;
                break;
        }
    });

export default cancellationFormReducer;
